import _get from 'lodash/get';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Form } from 'formik';
import { Row, Col, Button } from 'reactstrap';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import InputBox from '../../../components/InputBox/InputBox';
import SelectBox from '../../../components/SelectBox/SelectBox';
import {
  ENDORSEMENTS,
  LICENSE_CLASS_ITEM,
} from '../../../utils/constants';
import STYLES from '../STYLES';

const defaultValues = {
  license: '',
  count: '',
  year: '',
  notes: '',
  endorsements: '',
};

function validate(values) {
  let errors = {};
  if (!values.license) {
    errors.license = 'Required.';
  }
  if (!values.count) {
    errors.count = 'Required.';
  }
  if (!values.year) {
    errors.year = 'Required.';
  }

  return errors;
}

class DriverModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onSubmit = async (values) => {
    this.props.onClose(values);
  };

  render() {
    let { initialValues } = this.props;
    return (
      <Modal
        size={'lg'}
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
        className={''}
      >
        <ModalHeader toggle={this.props.toggle}>ADD DRIVER</ModalHeader>
        <ModalBody style={{ padding: 30 }}>
          <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validate={validate}
            onSubmit={this.onSubmit}
          >
            {({ handleSubmit, values }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={12}>
                      <Row>
                        <SelectBox
                          name={'license'}
                          options={LICENSE_CLASS_ITEM}
                          md='3'
                          label='License Type'
                        />
                        <InputBox md='3' name={'count'} label={'Count'} type="number" />
                        <InputBox md='3' name={'year'} label={'Year'} />
                        <SelectBox
                          name={'endorsements'}
                          options={ENDORSEMENTS}
                          md='3'
                          label='Endorsements'
                        />
                        <InputBox md='12' name={'notes'} label={'Notes'} />
                      </Row>
                    </Col>
                    <Col className='text-center'>
                      <button
                        color='primary'
                        type='submit'
                        className='btn btn-primary btn-sm'
                        style={STYLES.BUTTON_NEXT}
                      >
                        {'SAVE DRIVER'}
                      </button>
                      <div className='text-center'>
                        <Button color='link' onClick={this.props.toggle}>
                          Cancel
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              );
            }}
          </Formik>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    initialValues: {
      ...defaultValues,
    },
    business: _get(state, 'appData.business', {}),
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DriverModal);
